import React from 'react';
import { motion } from 'framer-motion';
const modules = [{
  n: '01',
  emoji: '📘',
  color: 'rose',
  title: 'Entender a la gente complicada',
  desc: 'Aprendé a detectar patrones emocionales y entender por qué ciertas personas generan tanto desgaste.',
  highlights: ['Mapa de patrones tóxicos', 'Diagnóstico de tu nivel de desgaste', 'Tipos de personalidades difíciles', 'Por qué te enganchás emocionalmente', 'Tu primer mapa de protección']
}, {
  n: '02',
  emoji: '📗',
  color: 'gold',
  title: 'Manipulación, culpa y desgaste emocional',
  desc: 'Detectá dinámicas manipuladoras antes de que afecten tu tranquilidad mental.',
  highlights: ['Las 7 tácticas más usadas por manipuladores', 'Cómo identificar la culpa inducida', 'Patrones de chantaje emocional', 'Cómo cortar el ciclo del desgaste', 'Protocolo de detección rápida']
}, {
  n: '03',
  emoji: '📙',
  color: 'rose',
  title: 'Cómo responder sin explotar',
  desc: 'Aprendé a comunicarte con más claridad y menos desgaste emocional.',
  highlights: ['6 técnicas de respuesta consciente', 'La pausa de 3 segundos que cambia todo', 'Cómo no reaccionar impulsivamente', 'Frases para mantener la calma', 'Comunicación firme y no agresiva']
}, {
  n: '04',
  emoji: '📕',
  color: 'gold',
  title: 'Límites sin culpa',
  desc: 'Cómo aprender a decir que no sin sentirte egoísta o conflictivo.',
  highlights: ['El protocolo del "no" sin culpa', 'Cómo sostener límites en el tiempo', 'Manejar reacciones de los demás', 'Diferenciar límite vs castigo', 'Tu sistema personal de límites']
}, {
  n: '05',
  emoji: '📓',
  color: 'rose',
  title: 'Cómo proteger tu energía mental',
  desc: 'Dejá de absorber tensión constante y recuperá paz mental.',
  highlights: ['Auditoría de tu entorno emocional', 'Cómo blindar tu energía mental', 'Protocolos de descompresión diaria', 'Rituales de cierre emocional', 'Tu ecosistema de bienestar']
}, {
  n: '06',
  emoji: '📔',
  color: 'gold',
  title: 'Casos reales y soluciones prácticas',
  desc: 'Ejemplos cotidianos y estrategias reales para manejar personas difíciles.',
  highlights: ['+20 casos reales analizados', 'Estrategias paso a paso', 'Familia, pareja, jefes y amigos', 'Frases listas para usar', 'Tu protocolo personal de respuesta']
}];
export function ModulesSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-219" data-mp="2wtilh1z8krlc">
      <div className="max-w-6xl mx-auto" data-id="element-220" data-mp="2strouhn13h8w">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-221" data-mp="2ssoxk8lsncsg">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-222" data-mp="xcnk1qr0usy">
            <span className="text-xs font-bold tracking-widest" data-id="element-223" data-mp="5wgyoxx8h2lx">
              🌸 6 MÓDULOS COMPLETOS
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-224" data-mp="ap0apqg9vpom">
            Más de 200 páginas.{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-225" data-mp="kktw7zbyytij">
              Todo resuelto.
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-226" data-mp="tmb9l9xzsh3j">
          {modules.map((m, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07,
          duration: 0.5
        }} className="bg-white border border-line rounded-3xl p-6 md:p-7 shadow-sm hover:shadow-lg transition-shadow" data-id="element-227" data-mp="tjxifc6fnp19" data-mpi={i}>
              <div className="flex items-start gap-4 mb-4" data-id="element-228" data-mp="253md9l329pnx">
                <div className={`flex-shrink-0 w-14 h-14 rounded-2xl flex items-center justify-center text-2xl ${m.color === 'rose' ? 'bg-rose/15' : 'bg-gold/15'}`} data-id="element-229" data-mp="1hd04tsp5a3de">
                  {m.emoji}
                </div>
                <div className="flex-1" data-id="element-230" data-mp="1r3l83tfrjw2n">
                  <div className={`text-xs font-bold tracking-widest mb-1 ${m.color === 'rose' ? 'text-rose' : 'text-gold'}`} data-id="element-231" data-mp="1mc38p9te23js">
                    MÓDULO {m.n}
                  </div>
                  <h3 className="font-serif font-bold text-xl md:text-2xl text-ink leading-tight uppercase" data-id="element-232" data-mp="tnxoqpa5sil0">
                    {m.title}
                  </h3>
                </div>
              </div>
              <p className="text-ink-soft text-sm md:text-base leading-relaxed mb-4" data-id="element-233" data-mp="3a1zlcu04zzcw">
                {m.desc}
              </p>
              <ul className="space-y-1.5 border-t border-line pt-4" data-id="element-234" data-mp="2vdwkfz0ybduy">
                {m.highlights.map((h, j) => <li key={j} className="text-sm text-ink-soft flex items-start gap-2" data-id="element-235" data-mp="30by34iugtb5w" data-mpi={j}>
                    <span className="text-rose mt-0.5" data-id="element-236" data-mp="3t0vh49rn8lsu">🌸</span>
                    {h}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        {/* Each module includes */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-line rounded-3xl p-7 md:p-10 mt-10 text-center shadow-sm" data-id="element-237" data-mp="3j0l34mxsbacm">
          <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink mb-6 uppercase tracking-tight" data-id="element-238" data-mp="95yyvwvcjp2m">
            Cada módulo incluye
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 text-left max-w-3xl mx-auto" data-id="element-239" data-mp="3vljqa3kwe0tg">
            {['Protocolos paso a paso', 'Ejercicios con guía completa', 'Páginas de journaling guiado', 'Técnicas listas para usar hoy', 'Checklists de implementación', 'Casos reales analizados'].map((t, i) => <div key={i} className="flex items-center gap-2.5 text-sm md:text-base text-ink" data-id="element-240" data-mp="3cmz3uotybjm5" data-mpi={i}>
                <span className="text-rose" data-id="element-241" data-mp="1frjcxzfry5zp">🌸</span>
                {t}
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}